module.exports = __webpack_public_path__ + "static/media/en.c42468c6.png";